const ModalEnum = {
  MAP: 'map',
  NEW_REPORT: 'newReport',
  ACCOUNT: 'account',
  USERS: 'users',
  GROUP: 'group',
  GEOFENCE: 'geofence',
  DEVICE: 'device',
  DRIVER: 'driver',
  NOTIFICATION: 'notification',
  CALENDAR: 'calendar',
  MAINTENANCE: 'maintenance',
  SERVER: 'server',
};

export default ModalEnum;
